import * as ActionTypes from './actionTypes'

export const NAME = 'map'

const initialState = {
  map: null,
  view: null,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_MAP_AND_VIEW:
      return {
        map: action.map,
        view: action.view,
      }
    default:
      return state
  }
}

export default reducer
